import CloseIcon from "@mui/icons-material/Close";
import { DialogTitle, Grid, IconButton } from "@mui/material";
import { ReactElement } from "react";
import { NO_DRAG_SELECTOR } from "../../../../app/constants";

type Props = {
  title: string | ReactElement;
  onClose: () => void;
};

const DialogHeader = ({ title, onClose }: Props) => {
  return (
    <Grid
      container
      justifyContent="space-between"
      alignItems="center"
      sx={{ cursor: "grab" }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          width: "100%",
          padding: "16px 0px",
          minHeight: "64px",
        }}
      >
        {title}
        <Grid item marginLeft="auto">
          <IconButton className={NO_DRAG_SELECTOR} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Grid>
      </DialogTitle>
    </Grid>
  );
};

export default DialogHeader;
